<template>
  <el-scrollbar wrap-class="scrollbar-wrapper">
    <el-menu
      :show-timeout="200"
      :default-active="$route.path"
      :background-color="variables.menuBg"
      :text-color="variables.menuText"
      :active-text-color="variables.menuActiveText"
      mode="vertical"
    >
      <div class="menu-wrapper">
      </div>
      <sidebar-item v-for="route in routes" :key="route.path" :item="route" :base-path="route.path"/>
    </el-menu>
  </el-scrollbar>
</template>

<script>
import {mapGetters} from 'vuex'
import variables from '@/styles/variables.scss'
import SidebarItem from './SidebarItem'

export default {
  components: {SidebarItem},
  data() {
    return {
      dialogVisible: false,
      AppList: []  // 动态获取的应用列表
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'name'
    ]),
    routes() {
      return this.$router.options.routes.filter(x => {
        if (x.hidden !== true) {
          if (x.name === 'Admin') {
            return this.$store.state.user.superadmin
          } else {
              x.children =   x.children.filter(xx => {
              if (xx.name === 'Admin') {
                return this.$store.state.user.superadmin
              } else {
                return true
              }
            })
             return true
          }
        }
      })
    },
    variables() {
      return variables
    },
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue